import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import {formatTimeHelper2} from '@/helpers/main_helper'

export type Props = {
  title: string;
  interval: string;
  subtitlePart?: string;
  hidden?: boolean;
  hideSubtitle?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'UiTitle',
  props: {
    title: null,
    interval: null,
    subtitlePart: null,
    hidden: { type: Boolean },
    hideSubtitle: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  interval: string;
  subtitlePart?: string;
  hidden?: boolean;
  hideSubtitle?: boolean;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", {
      class: _normalizeClass(["text-align-center footer-desc margin-none text-h5 template-h", [{ 'd-none': props.hidden }]]),
      "data-excelcolspan": "3",
      innerHTML: __props.title
    }, null, 10, _hoisted_1),
    _createElementVNode("p", {
      class: _normalizeClass(["text-align-center margin-none", [{ 'd-none': props.hidden }]])
    }, " за период " + _toDisplayString(__props.interval) + ". Отчет сформирован " + _toDisplayString(_unref(formatTimeHelper2)(new Date())), 3)
  ], 64))
}
}

})